<template>
    <p class="company-monitoring nochangepls" :data-ogrn="ogrn">
        <span v-if="hasMonitoring" :data-ogrn="ogrn">
            <span style="color: #009900">★ Включён мониторинг</span>
            <span v-if="getCategoryNameById" :style="categoryStyleColor(monitoredCompany.category_id)"> - {{getCategoryNameById}},</span>
            <span v-on:click="removeMonitoring" class="dashed">выключить.</span>
            <div v-if="showChangeCategoryMenu" class='company-monitoring__change-category'>
                <ul v-click-outside-element="closeChangeCategoryMenu">
                    <li>Изменить категорию</li>
                    <li @click="setCompanyCategory(1)"><i class="far fa-eye"></i> Без категории</li>
                    <li @click="setCompanyCategory(2)"><i class="fas fa-people-carry"></i> Поставщик</li>
                    <li @click="setCompanyCategory(7)"><i class="fas fa-user-slash"></i> Недобросовестный </li>
                    <li @click="setCompanyCategory(4)"><i class="fas fa-dolly-flatbed"></i> Клиент</li>
                    <li @click="setCompanyCategory(3)"><i class="fas fa-ghost"></i> Конкурент</li>
                    <li @click="setCompanyCategory(5)"><i class="fas fa-hand-holding-usd"></i> Должник</li>
                    <li @click="setCompanyCategory(8)"><i class="fas fa-sitemap"></i> Аффилирован</li>
                    <li @click="setCompanyCategory(6)"><i class="fas fa-crown"></i> VIP</li>
                </ul>
            </div>
        </span>
        <span v-on:click="addMonitoring" v-else class='dashed company-monitoring-set'>
            <span>☆</span>
            <span>Включить мониторинг</span>
        </span>
        <span v-if="monitoredCompanyCategories && monitoredCompanyCategories.length">
            <span>|</span>
            <span v-for="(e,i) in monitoredCompanyCategories" :key="i">
                <span :style="categoryStyleColor(e.id)">{{e.title}}</span>
                <span>в {{e.groups.join(', ')}}{{i != monitoredCompanyCategories.length - 1 ? ';' : '.'}}</span>
            </span>
        </span>
    </p>
</template>

<script>
export default {
    props: ['ogrn'],
    name: "monitoringSetDeleteButton",
    data() {
        return { showChangeCategoryMenu: false }
    },
    computed: {
        monitoredCompanyCategories() {
            return this.$store.state.monitoring.allCategories?.filter(e => parseInt(e.company_id) == parseInt(this.$props.ogrn))[0]?.categories
        },
        monitoredCompany() {
            return this.$store.state.monitoring.allCompanies?.filter(e => parseInt(e.company_id) == parseInt(this.$props.ogrn))[0]
        },
        getCategoryNameById() {
            return this.$store.getters['monitoring/getCategoryNameById'][this.monitoredCompany.category_id]
        },
        hasMonitoring(){
            const monitoringCompanies = this.$store.getters["monitoring/allCompaniesOgrns"]
            
            if(monitoringCompanies && monitoringCompanies.length){
                if(monitoringCompanies.filter(e => parseInt(e) == parseInt(this.$props.ogrn)).length) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        }
    },
    methods: {
        categoryStyleColor(categoryId) {
            const conditional = categoryId == 5 || categoryId == 7 || categoryId == 8
            return { color: conditional ? 'red' : '' }
        },
        closeChangeCategoryMenu() { this.showChangeCategoryMenu = false },
        setCompanyCategory(category_id) {
            try {
                this.$store.dispatch('monitoring/setCategory', {
                    companies: [this.$props.ogrn],
                    category_id
                }).finally(() => {
                    this.showChangeCategoryMenu = false
                })
            } catch {
                this.$store.dispatch("showErrorPopUp", "Категория не присвоена, ошибка API")
            }
        },
        addMonitoring(){
            try {
                this.$store.dispatch('monitoring/addCompany', this.$props.ogrn).then(() => {
                    this.showChangeCategoryMenu = true
                })
            } catch {
                this.$store.dispatch("showErrorPopUp", "Компания не добавлена, ошибка API")
            }
        },
        removeMonitoring(){
            this.$store.dispatch('monitoring/removeCompany', this.$props.ogrn)
        }
    }
}
</script>

<style lang="sass" scoped>
@import "styles/global-variables"

.company-monitoring
    max-width: 650px
    span
        font-weight: 100
    .lnr.lnr-chevron-down
        vertical-align: text-bottom
    &__change-category
        display: inline-block
        position: relative
        max-width: 200px
        ul
            padding: 10px
            margin: 0
            position: absolute
            background-color: white
            border-radius: 6px
            border: 1px solid lightgray
            z-index: 1
            li:first-child
                color: #555
            li:not(:first-child)
                @extend .blue-red-hover-text
                margin-top: 8px
                white-space: nowrap
                .fas, .fab, .far
                    font-size: 14px
                    margin-right: 5px
                    width: 20px
                    text-align: center
</style>
